import * as yup from 'yup';

export interface LaborSubclassDto {
  id?: number;
  companyId: number;
  laborClassificationId: number;
  name: string;
}

export interface LaborSubclassOptionsDto {
  subclasses: LaborSubclassDto[];
  source: 'Job' | 'Company';
  laborSubclassRequired: Record<number, boolean>;
}

export const laborSubclassInit: LaborSubclassDto = {
  companyId: -1,
  laborClassificationId: -1,
  name: ''
};

export interface LaborSubclassesParameters {
  page?: number;
  pageSize?: number;
  sortBy?: string;
  sortDirection?: 'asc' | 'desc';
  filterText: string;
}

export const laborSubclassesParametersInit: LaborSubclassesParameters = {
  page: 0,
  pageSize: 10,
  sortBy: 'name',
  sortDirection: 'asc',
  filterText: ''
};

export const laborSubclassValidationSchema = yup.object({
  companyId: yup.number().min(1, 'Company is required.').required('Company is required.'),
  laborClassificationId: yup.number().min(1, 'Labor Classification is required.').required('Labor Classification is required.'),
  name: yup.string().max(200, 'Name cannot be more than 200 characters.').required('Name is required.')
});
